"use strict";

var app = {
  settings: {},
  vars: {},
  init: function init() {
    this.initGlobalExtensions();
    this.initLocalExtensions($('body'));
  },
  parse: function parse($context) {
    this.initLocalExtensions($context);
  },
  initGlobalExtensions: function initGlobalExtensions() {
    var t = this;

    for (var globalExt in t.globalExt) {
      if (!app.obj[globalExt]) {
        app.obj[globalExt] = new t.globalExt[globalExt]();
      }
    }
  },
  initLocalExtensions: function initLocalExtensions($context) {
    var t = this;

    for (var ext in t.ext) {
      var $els = $context.findOrSelf('.js-' + ext);
      $els.each(function () {
        var fn = new t.ext[ext]($(this));
        $(this).data('obj_' + ext, fn);
        if (app.obj[ext] === undefined) app.obj[ext] = [];

        if ($(this).data('objectName')) {
          app.obj[ext][$(this).data('objectName')] = fn;
        } else {
          app.obj[ext].push(fn);
        }
      });
    }
  },
  ext: {},
  globalExt: {},
  obj: {}
};
$(function () {
  app.init();
});

$.fn.findOrSelf = function (selector) {
  return this.find(selector).add(this.filter(selector));
};

$(document).ready(function () {
  $('#applang').on('change', function () {
    var url = window.location.href;

    if (url.indexOf('&lang')) {
      var url_helper = url.split('&lang');
      url = url_helper[0];
    }

    window.location.href = url + '&lang=' + $(this).val();
  });
  onresize();
  $(window).resize(onresize);
});

function onresize() {
  $('.footer').hide(0);
  var win_height = $(window).innerHeight();
  var offset = $('.content').offset().top + $('.content').outerHeight();
  if (offset < win_height) offset = win_height;
  $('.footer').css({
    top: offset + 'px',
    display: 'block'
  });
}

app.globalExt['global-structure'] = function () {
  var api = {};

  var init = function init() {};

  init();
  return api;
};

app.ext['create'] = function ($el) {
  var api = {};

  var init = function init() {
    $el.on('click', function () {
      $('.js-store.active').find('.content').remove();
      $('.js-store.active').removeClass('active');
      window.scrollTo(0, 0);
      $.ajax({
        url: 'ajax.php',
        type: 'post',
        data: {
          action: 'empty'
        },
        success: function success(data) {
          $('.js-search-list').prepend('<li class="js-newstore active">' + data + '</li>');
        }
      });
    });
  };

  init();
  return api;
};

app.ext['form'] = function ($el) {
  var api = {};

  var init = function init() {
    // remove error on focus
    $el.find('input').on('focus', function () {
      $(this).removeClass('error');
    }); // radio toggle

    var r = '0';
    $el.find('input[type=radio]').on('click', function (e) {
      e.preventDefault();
      $('.checkbox.error').removeClass('error');
      setTimeout(function () {
        r = r == '0' ? '1' : '0';
        $('#tnb' + r).prop('checked', true);
      });
    }); // submit form

    $el.on('submit', function (e) {
      var error = false;
      $el.find('input[name=email]').removeClass('error');
      $el.find('.checkbox').removeClass('error');
      var data = $el.serializeArray();

      for (var i = 0; i < data.length; i++) {
        if (data[i].name == 'email' && !validateEmail(data[i].value)) {
          error = true;
          $el.find('input[name=email]').addClass('error');
        }

        if (data[i].name == 'tnb' && data[i].value != "1") {
          error = true;
          $el.find('.checkbox').addClass('error');
        }
      }

      if (error) {
        console.log('form error');
        e.preventDefault();
      }
    });
  };

  init();
  return api;
};

function validateEmail(email) {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

app.ext['local-structure'] = function ($el) {
  var api = {};

  var init = function init() {};

  init();
  return api;
};

app.ext['privacy'] = function ($el) {
  var api = {};

  var init = function init() {
    var country = $el.data('country'); // close privacy policy

    $('.overlay__close').on('click', function () {
      $('.overlay').removeClass('open');
      setTimeout(function () {
        $('.overlay').remove();
      }, 500);
    }); // open privacy policy

    $($el).on('click', function (e) {
      e.preventDefault();
      var $overlay = $('<div class="overlay"><div class="overlay__nav"><div class="overlay__close"></div></div><div class="overlay__content"></div></div>');
      $('body').append($overlay);
      var $overlay_content = $overlay.find('.overlay__content');
      $.ajax({
        url: '/get_privacy.php',
        type: 'get',
        data: {
          country: country
        },
        success: function success(response) {
          $overlay_content.append(response.html);
          $overlay.addClass('open');
          app.parse($el);
        }
      });
    });
  };

  init();
  return api;
};

app.ext['search'] = function ($el) {
  var api = {};

  var init = function init() {
    var $inp = $el.find('input').first();
    var $list = $('.js-search-list');
    var $list_items = $list.find('li');
    $inp.on('keyup', function () {
      var val = $(this).val();

      if (val.length < 1) {
        $list_items.removeClass('hidden');
      } else {
        $list_items.each(function () {
          if ($(this).find('.name').text().toLowerCase().indexOf(val.toLowerCase()) < 0) {
            $(this).addClass('hidden');
          } else {
            $(this).removeClass('hidden');
          }
        });
      }
    });
  };

  init();
  return api;
};

app.ext['store'] = function ($el) {
  var api = {};

  var init = function init() {};

  init();
  return api;
};

$(document).ready(function () {
  $(document).on('click', '.js-store', function () {
    var $clicked = $(this);

    if (!$clicked.hasClass('active')) {
      $('.js-store.active').find('.content').remove();
      $('.js-store.active').removeClass('active');
      $('.js-newstore').remove();
      $clicked.addClass('active');
      $.ajax({
        url: 'ajax.php',
        type: 'post',
        data: {
          id: $clicked.data('id'),
          action: 'get_store'
        },
        success: function success(data) {
          $clicked.append(data);
        }
      });
    }
  });
  $(document).on('change', 'select[name=country]', function () {
    var val = $(this).val();
    $('select[name=default_language]').addClass('hidden').prop('disabled', true);
    $('select.forcountry_' + val).removeClass('hidden').prop('disabled', false);
  });
  $(document).on('click', 'form .js-save-store', function () {
    var form = $(this).parents('form');
    var data = form.serializeArray();
    $.ajax({
      url: 'ajax.php',
      type: 'post',
      data: data,
      success: function success(data) {
        $('.js-store.active').find('.content').remove();
        $('.js-store.active').removeClass('active');
        show_flag('Store successfully saved!');
        reload();
      }
    });
  });
  $(document).on('click', '.js-delete-store', function () {
    if (confirm('Are you sure you want to delete this store?')) {
      $.ajax({
        url: 'ajax.php',
        type: 'post',
        data: {
          action: 'delete_store',
          id: $(this).data('id')
        },
        success: function success(data) {
          show_flag('Store successfully deleted!');
          reload();
        }
      });
    }
  });
  $(document).on('change', '.upload', handleUpload);
});
var doing = false;

function handleUpload(e) {
  var $this = $(e.target);

  if (doing == false) {
    doing = true;
    var id = $this.data('id');
    var fd = new FormData();
    var files = $this[0].files[0];
    fd.append('file', files);
    $.ajax({
      url: 'upload.php?id=' + id,
      type: 'post',
      data: fd,
      contentType: false,
      processData: false,
      success: function success(response) {
        if (response == '0') {
          alert('Upload failed, please check the uploaded file! Only JPG allowed.');
          doing = false;
        } else {
          $('#' + id).css({
            'background-image': 'url(data:image/jpg;base64,' + response + ')'
          });
          doing = false;
        }
      }
    });
  }
}

function reload() {
  $.ajax({
    url: 'ajax.php',
    type: 'post',
    data: {
      action: 'reload'
    },
    success: function success(data) {
      $('.js-search-list').empty();
      $('.js-search-list').append(data);
    }
  });
}

function show_flag(msg) {
  $('body').append('<div class="flag js-flag">' + msg + '</div>');
  setTimeout(function () {
    $('.js-flag').fadeOut(function () {
      $(this).remove();
    });
  }, 2000);
}